// Importing the Component base class from React to create class-based components
// Importing the ReactNode type to type props that can accept any valid React element or string/number
import { Component, type ReactNode } from 'react';


// Props interface: accepts any ReactNode children
interface Props {
  children: ReactNode;
}
// State interface: tracks if an error has occurred
interface State {
  hasError: boolean;
}
// ErrorBoundary class component
class ErrorBoundary extends Component<Props, State> {
  // Initialize state
  state: State = { hasError: false };
  // Update state when an error is thrown in a child component
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }
  // Lifecycle method to log error details
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }
  // Render fallback UI if an error occurred, otherwise render children
  render() {
    if (this.state.hasError) {
      return (
        <div className="container mx-auto p-4 text-red-500">
          <h1>Something went wrong.</h1>
          <p>Please try refreshing the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;